import { Alert, Box, Typography, useTheme } from '@mui/material';
import { createRoot, Root } from 'react-dom/client';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';

class BilberryStripeAlertWidget extends BilberryCustomElement {
    private root: Root | null = null;

    static get observedAttributes() {
        return ['errormessage'];
    }

    constructor() {
        super();
        this.root = createRoot(this._mountPoint);
    }

    attributeChangedCallback() {
        this.renderWidget();
    }

    protected renderWidget(): void {
        const errorMessage = this.getAttribute('errormessage') ?? '';

        this.root?.render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <StripeAlert errorMessage={errorMessage}></StripeAlert>
            </WidgetWrapper>,
        );
    }
}

function StripeAlert({ errorMessage }: { errorMessage: string }) {
    const theme = useTheme();
    const errorLines = errorMessage.split('\n');

    return (
        <Box sx={{ my: theme.spacing(2) }}>
            <Alert
                severity="error"
                sx={{
                    '& .MuiAlert-message': {
                        width: '100%',
                    },
                }}
            >
                {errorLines.map((line, i) => (
                    <Typography key={i} component="div">
                        {line}
                    </Typography>
                ))}
            </Alert>
        </Box>
    );
}

export default function defineCustomElement(): void {
    // Both the activities and the timeslots production bundle evaluate this module (via
    // StripePaymentWrapper -> initStripeWidget); a second define on one page would throw.
    if (!customElements.get('bilberry-stripe-alert')) {
        customElements.define('bilberry-stripe-alert', BilberryStripeAlertWidget);
    }
}
